import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { faGripDotsVertical } from "@fortawesome/pro-solid-svg-icons";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/design-system/Icon";

type Props = {
  listeners: SyntheticListenerMap | undefined;
  immutable?: boolean;
  className?: string;
  isGrabbing?: boolean;
  color?: string;
  size?: "xs" | "2xs";
};

export const ReorderHandle: React.FC<Props> = ({
  listeners,
  immutable = false,
  className,
  size = "xs",
  isGrabbing = false,
}) => (
  <button
    {...listeners}
    className={twJoin(
      immutable && "cursor-not-allowed",
      !immutable && (isGrabbing ? "cursor-grabbing" : "cursor-grab"),
      className,
    )}
    data-loc="reorder-handle"
    type="button"
  >
    <Icon icon={faGripDotsVertical} size={size} />
  </button>
);
